import { skipToken } from "@reduxjs/toolkit/query/react"
import { useGetUsersQuery } from "./api"
import type { Uuid } from "@/utils"

export const useGetUser = (id?: Uuid) =>
  useGetUsersQuery(
    id
      ? {
          ids: [id],
        }
      : skipToken,
    {
      selectFromResult: ({ data, isLoading, isUninitialized }) => ({
        user: data?.[0],
        isLoading: isLoading || isUninitialized,
      }),
    },
  )
